import type { ReactNode } from 'react';

import { AnimatedCheckmark } from '#/components/Icon/AnimatedCheckmark';
import { Body } from '#/components/Text/Body';
import { TabContext } from '#/containers/TabContext';

import {
  CheckmarkHolder,
  LargeCheckboxContainer,
  LargeCheckboxInput,
} from './LargeCheckbox.styled';

type Props = {
  qaId?: string;
  id?: string;
  name?: string;
  label: ReactNode;
  checked: boolean;
  hasError?: boolean;
  onChange: (arg0: boolean) => void;
  disabled?: boolean;
  fullWidth?: boolean;
};

export function LargeCheckbox({
  id,
  name,
  label,
  checked,
  hasError,
  onChange,
  disabled,
  fullWidth,
  qaId,
  ...props
}: Props) {
  return (
    <LargeCheckboxContainer
      $hasError={hasError}
      $checked={checked}
      $disabled={disabled}
      $fullWidth={fullWidth}
    >
      <div
        style={{
          top: 0,
          left: 0,
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
      >
        <TabContext.Consumer>
          {(isTabbing) => (
            <LargeCheckboxInput
              type="checkbox"
              name={name}
              id={id}
              checked={checked}
              onChange={(e) => {
                e.stopPropagation();
                onChange(e.target.checked);
              }}
              $isTabbing={isTabbing}
              disabled={disabled}
              data-qa-id={qaId}
              // oxlint-disable-next-line react/jsx-props-no-spreading
              {...props}
            />
          )}
        </TabContext.Consumer>
      </div>

      <CheckmarkHolder $checked={checked}>
        {checked && <AnimatedCheckmark size={16} colorName="white" />}
      </CheckmarkHolder>

      <Body
        tag="label"
        htmlFor={id}
        style={{
          lineHeight: 1.375,
          fontSize: 18,
          marginLeft: 14,
          marginBottom: 0.5,
        }}
      >
        {label}
      </Body>
    </LargeCheckboxContainer>
  );
}
